import React from 'react'
import { Slider } from '@/features/shadcn/ui/slider'
import { formatCompactCurrency } from '../../applications/Traffic/utils'

export interface BudgetSliderProps {
  channel: { channel: string; channelId: string; totalSpend: number; color: string }
  value: number
  onChange: (value: number) => void
  currency: string
}

export function BudgetSlider({ channel, value, onChange, currency }: BudgetSliderProps) {
  const safeValue = Math.max(value ?? channel.totalSpend ?? 0, 0)
  const maxBudget = Math.max(channel.totalSpend * 2.5, safeValue * 1.1)
  const percentage = channel.totalSpend > 0 ? ((safeValue - channel.totalSpend) / channel.totalSpend * 100) : 0

  return (
    <div className="tw-space-y-2">
      <div className="tw-flex tw-items-center tw-justify-between">
        <div className="tw-flex tw-items-center tw-gap-2">
          <div className="tw-w-3 tw-h-3 tw-rounded-full" style={{ backgroundColor: channel.color }} />
          <span className="tw-font-medium tw-text-slate-900">{channel.channel}</span>
        </div>
        <div className="tw-flex tw-items-center tw-gap-2">
          <span className="tw-font-semibold tw-text-slate-900">
            {formatCompactCurrency(safeValue, currency)}
          </span>
          <span className={`tw-text-sm ${percentage >= 0 ? 'tw-text-green-600' : 'tw-text-red-600'}`}>
            ({percentage >= 0 ? '+' : ''}{percentage.toFixed(0)}%)
          </span>
        </div>
      </div>
      <Slider
        value={[safeValue]}
        min={0}
        max={maxBudget}
        step={Math.max(100, Math.floor(maxBudget / 100))}
        onValueChange={(vals) => onChange(Math.max(0, vals[0] ?? 0))}
        className="tw-w-full"
      />
    </div>
  )
}
